import { Router } from '@angular/router';
import { Flutterwave, PaymentSuccessResponse } from 'flutterwave-angular-v3';
import Swal from 'sweetalert2';
import { AuthService } from './../../_services/auth.service';
import { EnrolService } from './../../_services/enrol.service';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InlinePaymentOptions } from 'flutterwave-angular-v3';
import { EnrolmentRequestInformation } from 'src/app/_models/EnrolmentRequestInformation';
import { Guardian } from 'src/app/_models/guardian';
import { SettlementChoiceData } from 'src/app/_models/payments/SettlementChoiceData';
import { ResultData } from 'src/app/_models/ResultData';
import { BillingService } from 'src/app/_services/billing.service';
import { SubjectService } from 'src/app/_services/subject.service';
import { StudentService } from './../../_services/student.service';

@Component({
  selector: 'app-enrol-upgrade',
  templateUrl: './enrol-upgrade.component.html',
  styleUrls: ['./enrol-upgrade.component.css']
})
export class EnrolUpgradeComponent implements OnInit {
  title = 'Premium';
  myForm;
  user_id: number = undefined
  errorSaving = false
  @Input() studentDetail: any = {}
  @Input() guardian = new Guardian()
  @Output() closeModalRequest = new EventEmitter<string>()
  server_level_id = 0
  subscriptionChoices = []
  subjects = []
  subscription=undefined
  subscriptions=undefined
  showButtons = false
  paymentData: InlinePaymentOptions
  paymentOrderId: string
  invoiceId: string
  billingInfo=undefined
  constructor(
    private studentService: StudentService,
    private subjectService: SubjectService,
    private authService: AuthService,
    private router: Router,
    private flutterwave: Flutterwave,
    private enrolService: EnrolService,
    private billingService:BillingService
  ) { }
  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {
    this.user_id = this.authService.gatePass.getValue().user_id

    this.subscriptions = this.studentDetail['subscriptions']
    this.errorSaving = false
    this.myForm = new FormGroup({
      coupon: new FormControl("", [Validators.required]),
      subscription_choice: new FormControl("", [Validators.required])
    });
    this.setCurrentSubscription()
    this.subscriptionChoices =this.subscription['subscription_choices']
    this.server_level_id = this.subscription.server_level_id
    this.subjectService.getSubjectsIdAndNameByLevel(this.server_level_id).subscribe(
      {next:(data:ResultData)=>{
        this.subjects = data.rs.data
      },error:(err)=>{
        console.error("Error retrieving subject by level",err)
      }
      }
    )
  }
  on_submit() {
    this.paymentOrderId = this.generatePaymentOrderId()

    let subscription_choice = this.billingService.getSettlementChoice(this.billingInfo,this.myForm.value.subscription_choice)
    this.paymentData = this.initializeRavePaymentData(subscription_choice)



    let eInfo = new EnrolmentRequestInformation()
    eInfo.server_guardian_id = this.studentDetail.server_guardian_id
    for (let i = 0; i < this.subjects.length; i++) {
      let dd = this.enrolService.formatData(this.myForm.value, this.studentDetail, this.subjects[i].id,this.subscription, "upgrading")
      dd.is_upgrading = 1
      eInfo.requests.push(dd)
    }
    let settlementChoice = new SettlementChoiceData()
    settlementChoice.subscription_choice=subscription_choice.name
    settlementChoice.payment_mode=this.myForm.value.payment_mode
    settlementChoice.server_billing_chart_id=+subscription_choice['server_billing_chart_id']
    settlementChoice.amount=+subscription_choice['amount']
    settlementChoice.payment_info.paymentOrderId=this.paymentOrderId
    settlementChoice.subscription_choice=subscription_choice.name
    eInfo.settlement_choice=settlementChoice
    this.studentService.enrolSaveInvoice(eInfo).subscribe({
      next:(data: ResultData) => {

        let invoiceData = data.rs.data

        this.invoiceId = invoiceData['id']
        this.makePayment()
        this.closeModal()
      },
      error: (err)=> {
        console.error('Error sending POST request:', err);
      },
    });

  }

  closeModal() {
      this.closeModalRequest.emit("myUpgradeEnrolmentModal")
    }
  setCurrentSubscription(){
    for (let i = 0; i < this.subscriptions.length; i++) {
      let s = this.subscriptions[i]

      if(s.is_current){
        this.subscription=s
        this.billingInfo=s['billing_info']
        break;
      }
    }
  }



  onShowPaymentModes() {
    this.showButtons = true
  }
  generatePaymentOrderId() {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  redirectOTP(data) {
    var link = data.link
    window.location.href = link
  }
  timer(ms) {
    return new Promise(res => setTimeout(res, ms));
  }

  somethingWentWrong() {
    Swal.fire('Oops', "Some thing went wrong. Contact boldungu team for assistance", 'info');
  }

  initializeRavePaymentData(paymentChoice: any) {
    let paymentData = new InlinePaymentOptions()
    paymentData.tx_ref = this.paymentOrderId
    paymentData.public_key = "FLWPUBK-82059e480cc436a947edd82516b4c040-X"
    paymentData.payment_options = 'mobilemoney'
    paymentData.meta = { 'consumer_id': '7898', 'consumer_mac': 'kjs9s8ss7dd' }
    paymentData.customer = { name: this.guardian.fullname, email: this.guardian.email, phone_number: '08100000000' }
    paymentData.callback = this.makePaymentCallback
    paymentData.onclose = this.closedPaymentModal
    paymentData.callbackContext = this
    paymentData.customizations = { title: 'Boldungu Payment', description: 'Payment Service', logo: '/assets/images/boldungu_logo.png' }
    paymentData.amount = paymentChoice['amount']
    paymentData.currency = paymentChoice['currency']

    return paymentData
  }
  makePayment() {

    this.flutterwave.inlinePay(this.paymentData)
  }
  makePaymentCallback(response: PaymentSuccessResponse): void {
    if (response.status == 'success') {
      let pData = this.enrolService.formatProvisionData(this.invoiceId, response, this.paymentData, 0, this.guardian.server_guardian_id)
      this.studentService.enrolProvision(pData).subscribe(
        x => {
          this.closedPaymentModal()
          this.router.navigate(['/guardian/show', this.guardian.server_user_id])
        }
      )
    }
    this.closedPaymentModal()

  }
  closedPaymentModal(): void { }
}


